import { updateA2eModel } from '@/services/api';
import { A2eModel } from '@d-id/types';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useRef, useState } from 'react';
import { SectionContainer } from '../../../../AdvancedEditor/components/panels/common/SectionContainer';
import { SectionTitle } from '../../../../AdvancedEditor/components/panels/common/SectionTitle';
import { FinetuneModelDropdown } from './FinetuneModelDropdown';

const Text = styled.div`
    color: var(--Secondary-Primary, #090604);
    text-align: left;
    font-family: 'Manrope', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.32px;
`;

const StyledSectionTitle = styled(SectionTitle)`
    gap: 12px;
`;

export const AdvancedSettings = observer(({ avatarId, currentA2eModel }: { avatarId: string; currentA2eModel?: A2eModel }) => {
    const advancedSettingsSection = useRef<HTMLDivElement>(null);
    const [isAdvancedSettingsExpanded, setIsAdvancedSettingsExpanded] = useState(false);
    const [selectedModel, setSelectedModel] = useState('');

    async function handleModelChange(model: string) {
        setSelectedModel(model);
        await updateA2eModel(avatarId, { a2e_model: model });
    }

    return (
        <>
            {
                <SectionContainer ref={advancedSettingsSection}>
                    <StyledSectionTitle
                        text="Advanced settings"
                        show={isAdvancedSettingsExpanded}
                        setShow={setIsAdvancedSettingsExpanded}
                    />
                    {isAdvancedSettingsExpanded && (
                        <>
                            <Text>Model</Text>
                            <FinetuneModelDropdown
                                options={[A2eModel.Baseline, A2eModel.Finetuned]}
                                selected={selectedModel || currentA2eModel || A2eModel.Baseline}
                                onChange={handleModelChange}
                            />
                        </>
                    )}
                </SectionContainer>
            }
        </>
    );
});
